import { createGlobalStyle } from "styled-components";
export const GlobalCarouselStyles = createGlobalStyle`

  .top-head {
    .custom-carousel {
      .cmp-carousel {
        padding: 0;

        &__indicators {
          justify-content: center;
          width: 100% ;
          padding: 10px;
          left: 0;
          margin: 30px 0 30px 0;
        }

        &__actions {
          display: none;
        }
        &__item img {
          height: auto;
        }
      }
    }
  }

  .top-venture {
    margin-bottom: 20px;
    .custom-carousel {
      .cmp-carousel {
        padding: 0;

        &__indicators {
          display: flex;
          justify-content: center;
          position: relative;
          bottom: 16px;
          left: 30px;
          width: 50%;

          @media (min-width: 768px) {
            width: 75%;
            bottom: 25px;
            left: 10%;
          }
        }

        &__actions {
          display: flex;
          justify-content: flex-end;
          bottom: -17px;
          gap: 5px;
          position: relative;
          margin: 0 10px;
        }

        .cmp-carousel__indicator {
          margin: 8px;

          &--active {
            margin: 3px;
            bottom: 0;
            @media (min-width: 768px) {
            }
        }
        
        &--active,
        &:hover,
        &:focus{
          margin: 3px;
          bottom: 0px;
        }
      }
      }
    }
  }

  .dream-and-live {
    .custom-carousel {
      .cmp-carousel {
        padding: 20px 0 0;

        @media (min-width: 879px) {
          &__indicators {
            justify-content: center;
            left: 20px;
          }
        }
      }
    }
  }

  .top-new {
    .custom-carousel {
      .cmp-carousel {
        padding: 0;
        &__actions {
          justify-content: space-between;
          bottom: unset;
          gap: 0;
          margin: 0;
          position: absolute;
          top: 49%;
          width: 100%;
          padding: 0 16px;
          
          @media (min-width: 768px) {
            top: 45%;
          }
        }

        &__indicators {
          display: none;
        }

        &__item {
          img {
            height: auto;
          }
        }
      }
    }
  }

  .custom-carousel {
    /* display: flex;
    justify-content: center; */
    .cmp-carousel {
      position: relative;
      width: 100%;
      /* max-width: 840px; */
      overflow: hidden;
      height: auto;
      padding: 20px 20px 0px 20px; 

      &__content {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        overflow: hidden;
      }

      &__item {
        position: relative;
        text-align: center;
        overflow: hidden;
        
        img {
          width: 100%;
          object-fit: cover;
          object-position: center;
          height: 590px;
        }
      }

      &__actions {
        display: flex;
        justify-content: flex-end;
        bottom: -17px;
        gap: 10px;
        position: relative;

        .cmp-carousel__action {
          border-radius: 50%;
          width: 40px;
          height: 40px;
          background-color: #079d56;
          border: none;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 8;

          &:disabled {
            background: #D9DDDB;

            .cmp-carousel__action-icon {
              border: solid #999E9C;
            }
          }

          .cmp-carousel__action-icon {
            width: 10px;
            height: 10px;
            border: solid white;
            transform: rotate(135deg);
          }

          &--previous {
            .cmp-carousel__action-icon {
              border-width: 0 3px 3px 0;
              left: 1px;
              position: relative;
            }

            &:disabled {
              .cmp-carousel__action-icon {
                border-width: 0 3px 3px 0;
              }
            }
          }

          &--next {
            .cmp-carousel__action-icon {
              border-width: 3px 0 0 3px;
              right: 1px;
              position: relative;
            }
            &:disabled {
              .cmp-carousel__action-icon {
                border-width: 3px 0 0 3px;
              }
            }
          }

          &--play,
          &--pause {
            display: none;
          }
        }
      }

      &__indicators {
        display: flex;
        justify-content: flex-start;
        gap: 2px;
        position: relative;
        bottom: 5px;
        left: 0;
        z-index: 7;

        .cmp-carousel__indicator {
          width: 9px;
          height: 9px;
          background: #D9DDDB;
          border-radius: 50%;
          border: none;
          cursor: pointer;

          &--active,
          &:hover,
          &:focus{
            background: transparent;
            border: 2px solid #079D56;
            width: 18px;
            height: 18px;
            bottom: 4px;

            &::after {
              content: "";
              display: block;
              width: 8px;
              height: 8px;
              background: #079d56;
              border-radius: 50%;
              margin: auto;
              position: relative;
              top: 3px;
            }
            
            &::before {
              display: none;
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) {
    .top-head {
      .custom-carousel {
        .cmp-carousel {
          margin-top: 100px;
        }
      }
    }
    .custom-carousel {
      .cmp-carousel {
        &__actions {
          .cmp-carousel__action {
            width: 44px;
            height: 44px;
          }
        }

        &__indicators {
          justify-content: center;
          left: 20px;
        }
      }
    }

    .neighbors {
      .embed-container{
        .embed-style{
          .embed-image{
            img{
              height: 500px !important;
            }
          }
        }
      }
      .custom-carousel {
        display: flex;
        justify-content: center;
        .cmp-carousel {
          width: 850px;
          &__item {
            border-radius: 16px;
            height: 500px;
          }
        }

      }
    }

  }

  .green {
    .custom-carousel {
      .cmp-carousel {
        &__action {
            background-color: #079d56;
          }
        &__indicators {
          .cmp-carousel__indicator {
  
            &--active,
            &:hover,
            &:focus{
              border: 2px solid #079D56;
  
              &::after {
                background: #079d56;
              }
            }
          }
        }
      }
    }
  }

  .purple {
    .custom-carousel {
      .cmp-carousel {
        &__action {
            background-color: #AC41D8;
          }
        &__indicators {
          .cmp-carousel__indicator {
  
            &--active,
            &:hover,
            &:focus{
              border: 2px solid #AC41D8;
  
              &::after {
                background: #AC41D8;
              }
            }
          }
        }
      }
    }
  }
  
  .orange {
    .custom-carousel {
      .cmp-carousel {
        &__action {
            background-color: #FF8B22;
          }
        &__indicators {
          .cmp-carousel__indicator {
  
            &--active,
            &:hover,
            &:focus{
              border: 2px solid #FF8B22;
  
              &::after {
                background: #FF8B22;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 426px) {
    .mobile-small {
      .cmp-carousel__item img {
          max-height: 215px;
      }
    }
  }
`;
